import React from 'react'
import styled from 'styled-components'

/**
 * Google Mapに配置するマーカー
 */
const Marker: React.FC<MarkerProps> = (props) => {
  return props.lat && props.lng ? (
    <StyledMarker {...props}>{props.component}</StyledMarker>
  ) : (
    <React.Fragment />
  )
}

export type MarkerProps = {
  component: React.ReactNode
  lat: number
  lng: number
}

export const StyledMarker = styled.div`
  position: absolute;
`

export default Marker
